import {
  FC, useCallback, useEffect, useMemo,
} from 'react'
import { Form, Formik } from 'formik'
import cn from 'classnames'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from '@src/components/Button/Button'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import style from '@src/components/Notification/Notification.module.scss'
import { phoneRegexp } from '@src/lib/regex'
import { validateForm } from '@src/messages/validateForm'
import { changePhone } from '@src/store/ducks/user/thunks'
import {
  selectIsLoadingChangePhoneNotification,
  selectUserInfo, selectUserIsSuccessChangePhone,
} from '@src/store/ducks/user/selectors'
import { AppDispatch } from '@src/store/store'
import { SetNewPhoneType } from '@src/api/user-api'
import { Modal } from '@src/components/common/Modal/Modal'
import { setIsSuccessChangePhone } from '@src/store/ducks/user/reducer'

const validationSchema = Yup.object().shape({
  phone: Yup.string().when('oldPhone', {
    is: true,
    then: Yup.string().matches(phoneRegexp, validateForm.phone).required(validateForm.required),
  }),
})

type NotificationProps = {
  newClass?: string
}

export const Notification: FC<NotificationProps> = ({ newClass }) => {
  const dispatch = useDispatch<AppDispatch>()
  const user = useSelector(selectUserInfo)
  const isLoading = useSelector(selectIsLoadingChangePhoneNotification)
  const isSuccessChangePhone = useSelector(selectUserIsSuccessChangePhone)

  useEffect(() => () => {
    dispatch(setIsSuccessChangePhone(false))
  }, [dispatch])

  const initialValues = useMemo(() => ({
    oldPhone: user.phoneNotify ?? '',
    phone: user.phoneNotify ?? '',
    type: SetNewPhoneType.NOTIFY,
  }), [user.phoneNotify])

  const closeModal = useCallback(() => {
    dispatch(setIsSuccessChangePhone(false))
  }, [dispatch])

  return (
    <div className={style.notifications}>
      <div>
        <h3 className={style.title}>
          Настройка уведомлений
          {/* {user.phoneNotify ? 'Отключить уведомления' : 'Настройка уведомлений'} */}
        </h3>
        <Formik
          validationSchema={validationSchema}
          initialValues={initialValues}
          enableReinitialize
          onSubmit={(values) => { dispatch(changePhone(values)) }}
        >
          {() => (
            <Form className={cn(newClass)}>
              <FieldFormik
                // disabled={!!user.phoneNotify}
                name="phone"// {user.phoneNotify ? 'oldPhone' : 'phone'}
                placeholder="+375 (ХХ) ХХХ ХХ ХХ"
                label="Получать SMS-уведомления" // label={user.phoneNotify ? 'Отказаться от SMS-уведомлений' : 'Получать SMS-уведомления'}
                mask="+{375} (00) 000-00-00"
              />
              <div className={style.buttonBlock}>
                <Button loading={isLoading} htmlType="submit" type="primary" className={style.btnSize}>
                  Подписаться
                  {/* {user.phoneNotify ? 'Отказаться' : 'Подписаться'} */}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <Modal isOpen={isSuccessChangePhone} close={closeModal}>
        <>
          <div className={style.confirmActions}>
            Ваше изменения были
            <span className="blue"> успешно сохранены</span>
            {' '}
          </div>
        </>
      </Modal>
    </div>
  )
}
